module.exports = __webpack_public_path__ + "img/icon-requirement.f2d24db7.svg";